import React from 'react';
import cta from './modaldictionary';
import Buttons from '../Buttons/Buttons';
import { useSelector } from 'react-redux';
import Proyecto from '../proyecto/Proyecto';
import './modal.css';

const Modal = (estado,cambiarEstado) => {
    const lang = useSelector((state) => state.lang.lang);
    return(
        <>
            {estado.estado.on &&    
                <div id="modal" className='modal'>
                    <div className='contenedor' id="modal_contenedor">
                        {/* <div onClick={()=>{estado.cambiarEstado({type:null,on:false})}} className='modal_close material-symbols-outlined'>close</div> */}
                        {estado.estado.type === 'proy' &&
                            <Proyecto key={`proy_${estado.estado.id}`} id={estado.estado.id} cat={estado.estado.cat}></Proyecto>
                        } 
                        <div className='modal-boton'><Buttons type={'primary'} onClick={()=>{estado.cambiarEstado({type:null,on:false})}} cta={cta[lang]}></Buttons></div>
                    </div>
                </div>
            }
        </>
    )
}

export default Modal;